import React from "react";
import { Modal, Button } from "react-bootstrap";
import { getImageUrl } from '../../../../utils/imageUrl';
import './SellerSuccessModal.css';

interface SellerSuccessModalProps {
  show: boolean;
  handleClose: () => void;
  title?: string;
  message?: string;
  buttonLabel?: string;
  imageName?: string; // Optional custom image name
}

export const SellerSuccessModal = ({
  show,
  handleClose,
  title = 'Seller Created Successfully',
  message = 'Seller has been created successfully',
  buttonLabel = 'OK',
  imageName = 'admin/static-assets/shop-services/boy-doing-mega-sale-announcement.webp',
}: SellerSuccessModalProps) => {
  return (
    <Modal 
      show={show} 
      onHide={handleClose} 
      id="sellerSuccessModal" 
      className="seller-success-modal fade zoomIn" 
      dialogClassName="modal-dialog-centered"
      centered
    >
      <Modal.Body className="seller-success-modal-body">
        <div className="seller-success-content">
          {/* Illustration Image */}
          <div className="seller-success-image-container">
            <img 
              src={getImageUrl(imageName)} 
              alt="Success" 
              className="seller-success-image"
            />
          </div>
          
          {/* Heading */}
          <h4 className="seller-success-title">{title}</h4>
          
          {/* Message */}
          <p className="seller-success-message">{message}</p>
          
          {/* Button */}
          <div className="seller-success-button-container">
            <Button 
              type="button" 
              variant="primary" 
              className="seller-success-button" 
              onClick={handleClose}
            >
              {buttonLabel}
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
